import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import {
  context_styles
} from "../context_builder_dark_styles";
import "../context_dark.css";
import { LinearProgressDark } from "../context_components/styled_linear_progress";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSpring, animated } from '@react-spring/web';
import { analysisActions, contextBuilderActions } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { Collapse } from "@mui/material";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faBarsStaggered } from '@fortawesome/free-solid-svg-icons';
import LinearAnalysis from "./audit_analysis_tabs/linearAnalysis";
import DrilldownAnalysis from "./audit_analysis_tabs/drillDownAnalysis";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import CameraIcon from '@mui/icons-material/Camera';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PptxGenJS from 'pptxgenjs';
import { store } from "../../store/store";
import { Projects } from "../context_components/projects";
import { BootstrapTooltip } from "../context_components/bootstrapTooltip";

export default function Analyze(props) {
  const { projectInfo, dateTime } = useSelector(state => state.projectInfoStore);
  const {
    skuInfoRaw,
    brands,
    variants,
    skus,
    selectedAudit
  } = useSelector(state => state.defaultTabStore);
  const {
    color
  } = useSelector(state => state.themeStore);
  const analysisData = useSelector(state => state.imageAnalysisStore);
  const {
    showBlurredImages,
    analysisOptions,
    activeAnalysisTab,
    linearAnalysis,
    drillDownAnalysis
  } = useSelector(state => state.analysisStore);
  const dispatch = useDispatch();
  const showBoxes = analysisOptions.showBoxes.selected;
  const blurryImages = analysisOptions.blurryImages.selected;
  const snapshot = analysisOptions.snapshot.selected;
  const imageInfo = analysisOptions.imageInfo.selected;
  const AI = analysisOptions.AI.selected;
  const HI = analysisOptions.HI.selected;

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0
    },
    config: {
      mass: 7
    }
  }))

  useEffect(() => {
    api.start({
      from: {
        y: -15 + "%"
      },
      to: {
        y: 0 + "%"
      }
    })
  }, [])

  useEffect(() => {

  }, [linearAnalysis, drillDownAnalysis, analysisData, snapshot])

  const handlePageChange = () => {
    dispatch(contextBuilderActions.changePage("default"))
  }


  const changeActiveTab = (activeTab) => {
    // logic for changing active tab
    dispatch(analysisActions.changeActiveTab(activeTab));

    if (activeTab === "linearAnalysis") {
      dispatch(analysisActions.resetStateByType({
        type: "linearAnalysis",
        updatedState: {
          selectedBrands: [],
          selectedVariants: [],
          selectedSkus: [],
          currentSelectedType: "",
          colors: {}
        }
      }))
    } else if (activeTab === "drillDownAnalysis") {
      dispatch(analysisActions.resetStateByType({
        type: "drillDownAnalysis",
        updatedState: {
          selectedBrand: [],
          selectedVariant: [],
          selectedSku: [],
          currentSelectedType: "",
          brandOptions: [],
          variantOptions: [],
          skuOptions: [],
          colors: {}
        }
      }))
      dispatch(analysisActions.resetStateByType({
        type: "linearAnalysis",
        updatedState: {
          selectedBrands: [],
          selectedVariants: [],
          selectedSkus: [],
          currentSelectedType: "",
          colors: {}
        }
      }))
    }
  }

  const toggleBlurredImages = () => {
    dispatch(analysisActions.toggleBlurredImages(!showBlurredImages));
  }

  const rgbaToHex = (rgba) => {
    const parts = rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

    if (!parts) {
      return null;
    }

    const [_, red, green, blue, alpha] = parts;

    const hexRed = parseInt(red).toString(16).padStart(2, "0");
    const hexGreen = parseInt(green).toString(16).padStart(2, "0");
    const hexBlue = parseInt(blue).toString(16).padStart(2, "0");
    const hexAlpha = alpha ? Math.round(parseFloat(alpha) * 255).toString(16).padStart(2, "0") : "FF";

    // `#${hexRed}${hexGreen}${hexBlue}${hexAlpha}` - with alpha channel
    // removing alpha value because it is not compatible with pptxgenjs library
    return `#${hexRed}${hexGreen}${hexBlue}`;
  }

  const generate_analysis_ppt = async () => {
    return new Promise((resolve, reject) => {
      const pptx = new PptxGenJS();
      const analysisDataLatest = store.getState().imageAnalysisStore;
      const images = Object.keys(analysisDataLatest);

      for (let i = 0; i < images.length; i++) {
        const element = document.getElementById(analysisDataLatest[images[i]].imgNo);
        console.log('elem', element, analysisDataLatest, analysisDataLatest[images[i]], analysisDataLatest[images[i]].imgNo);
        const base64Image = element.toDataURL("image/jpeg");

        // restructuring colors object
        let colors = activeAnalysisTab === "linearAnalysis"
          ? linearAnalysis.colors
          : drillDownAnalysis.colors

        colors = Object.keys(colors).length > 0
          ? Object.keys(colors).map(r => {
            return {
              name: r,
              color: colors[r]
            }
          })
          : []

        // only including images whose base64 string exists
        if (base64Image.length > 0) {
          const slide = pptx.addSlide();
          slide.addImage({ data: base64Image, x: 1, y: 0.2, w: 2.5, h: 5 });

          // looping through colors to create legend
          let y_init = 0;
          if (colors.length > 0) {
            for (let j = 0; j < colors.length; j++) {
              y_init = y_init + 0.3;
              slide.addShape(pptx.shapes.ROUNDED_RECTANGLE, {
                x: 4,
                y: y_init,
                w: 0.2,
                h: 0.2,
                rectRadius: 1,
                fill: { color: rgbaToHex(colors[j]["color"]) },
              });
              slide.addText(colors[j]["name"], {
                x: 4.5,
                y: y_init + 0.1,
                fontFace: "Arial",
                fontSize: 12,
                color: rgbaToHex("rgba(0, 0, 0, 1)"),
              });
            }

          } else {
            slide.addShape(pptx.shapes.ROUNDED_RECTANGLE, {
              x: 4,
              y: 0.2,
              w: 0.2,
              h: 0.2,
              rectRadius: 1,
              fill: { color: rgbaToHex("rgba(0, 255, 255, 0.65)") },
            });
            slide.addText("All Brands", {
              x: 4.5,
              y: 0.3,
              fontFace: "Arial",
              fontSize: 12,
              color: rgbaToHex("rgba(0, 0, 0, 1)"),
            });
          }
        }
      }

      pptx.writeFile(selectedAudit + '.pptx');
      resolve("done")
    })
  }

  const handleAnalysisOptionChange = async (type) => {
    dispatch(analysisActions.toggleAnalysisOptions({
      type: type,
      value: !analysisOptions[type]["selected"]
    }))

    if (type === "snapshot") {
      await generate_analysis_ppt();
    }
  }

  let activeTab;
  if (activeAnalysisTab === "linearAnalysis") {
    activeTab = (<LinearAnalysis />)
  } else if (activeAnalysisTab === "drillDownAnalysis") {
    activeTab = (<DrilldownAnalysis />)
  }

  return (
    <animated.div style={{ ...springs }}>
      <Paper elevation={5} sx={context_styles}>
        {props.load &&
          <LinearProgressDark className="context-loader-dark" />
        }
        <Stack className="brand-analysis" spacing={0} sx={{ p: 1 }}>
          <Stack direction="row" className="page-header-dark">
            <ChevronLeftIcon className="left-dark" onClick={handlePageChange} />
            <span>Analyze</span>
            <div className="right-dark"></div>
          </Stack>

          <Stack className="view-switcher" direction="row">

            <Stack
              spacing={1}
              direction="row"
              onClick={() => changeActiveTab("linearAnalysis")}
              className={activeAnalysisTab === "linearAnalysis" ? "view-option selected-view-option" : "view-option"}
              sx={{
                ":hover": {
                  color: color
                },
                "color": (activeAnalysisTab === "linearAnalysis") ? color : "rgba(245, 245, 245, 0.75)"
              }}
            >
              <FontAwesomeIcon className="view-icon" icon={faBarsStaggered} />
              <span className="view-text">Linear</span>
            </Stack>

            <Stack
              spacing={1}
              direction="row"
              onClick={() => changeActiveTab("drillDownAnalysis")}
              className={activeAnalysisTab === "drillDownAnalysis" ? "view-option selected-view-option" : "view-option"}
              sx={{
                ":hover": {
                  color: color
                },
                "color": (activeAnalysisTab === "drillDownAnalysis") ? color : "rgba(245, 245, 245, 0.75)"
              }}
            >
              <FontAwesomeIcon className="view-icon" icon={faLayerGroup} />
              <span className="view-text">Drilldown</span>
            </Stack>

          </Stack>

          <div className="option-container">
            <Stack
              spacing={1}
              direction="row"
              className="option-icons"
            >
              <BootstrapTooltip title="toggle AI images" placement="top">
                <span
                  style={{
                    fontSize: "0.9rem",
                    color: AI ? color : "rgba(245, 245, 245, 0.35)",
                    cursor: "pointer"
                  }}
                  onClick={() => handleAnalysisOptionChange("AI")}
                >AI</span>
              </BootstrapTooltip>
              <BootstrapTooltip title="toggle HI images" placement="top">
                <span
                  style={{
                    fontSize: "0.9rem",
                    color: HI ? color : "rgba(245, 245, 245, 0.35)",
                    cursor: "pointer"
                  }}
                  onClick={() => handleAnalysisOptionChange("HI")}
                >HI</span>
              </BootstrapTooltip>
            </Stack>
            <Stack
              spacing={1}
              direction="row"
              className="option-icons"
            >
              <BootstrapTooltip title="toggle boxes" placement="top">
                <CheckBoxOutlineBlankIcon
                  sx={{
                    fontSize: "1.15rem",
                    color: showBoxes ? color : "rgba(245, 245, 245, 0.35)",
                    cursor: "pointer"
                  }}
                  onClick={() => handleAnalysisOptionChange("showBoxes")}
                />
              </BootstrapTooltip>
              <BootstrapTooltip title="toggle blurry images" placement="top">
                <BlurOnIcon
                  sx={{
                    fontSize: "1.15rem",
                    color: blurryImages ? color : "rgba(245, 245, 245, 0.35)",
                    cursor: "pointer"
                  }}
                  onClick={() => handleAnalysisOptionChange("blurryImages")}
                />
              </BootstrapTooltip>
              <BootstrapTooltip title="take a snapshot of analysis" placement="top">
                <CameraIcon
                  sx={{
                    fontSize: "1.15rem",
                    color: color,
                    cursor: "pointer"
                  }}
                  onClick={() => handleAnalysisOptionChange("snapshot")}
                />
              </BootstrapTooltip>
              <BootstrapTooltip title="toggle image info" placement="top">
                <ErrorOutlineIcon
                  sx={{
                    fontSize: "1.15rem",
                    color: imageInfo ? color : "rgba(245, 245, 245, 0.35)",
                    cursor: "pointer",
                    transform: "rotate(180deg)"
                  }}
                  onClick={() => handleAnalysisOptionChange("imageInfo")}
                />
              </BootstrapTooltip>
            </Stack>
          </div>

          <Collapse in={skuInfoRaw.length > 0} timeout={350} unmountOnExit>
            {activeTab}
          </Collapse>
        </Stack>

        {/* project info/switcher */}
        <Projects />
      </Paper>
    </animated.div>
  )
}